// extracted by mini-css-extract-plugin
export default {"cell":"_1EXnv","content":"_3vVMi","today":"_1yNDW","active":"_1V3V4","border":"_3LGw6","withEvents":"_1SeLb","day":"_3mBjv","otherMonth":"_3ZG0C"};